// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"608":"e845ba1f","830":"415be9a6","930":"e650b4d9"}[chunkId] + ".chunk.js";
};